import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const SectionCount = ({ numbers }) => {
  const [counts, setCounts] = useState(numbers.map(() => 0));
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.35,
  });

  useEffect(() => {
    if (inView) {
      const intervals = numbers.map((number, index) => {
        const step = Math.ceil(number.num / 60);
        return setInterval(() => {
          setCounts((prevCounts) => {
            const updatedCounts = [...prevCounts];
            updatedCounts[index] = Math.min(
              updatedCounts[index] + step,
              number.num
            );
            return updatedCounts;
          });
        }, 20);
      });

      return () => {
        intervals.forEach(clearInterval);
      };
    }
  }, [inView, numbers]);

  return (
    <motion.div
      ref={ref}
      className="section-count mt-6 grid grid-cols-2 gap-3 sm:gap-4"
      initial={{ opacity: 0, y: 12 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
    >
      {numbers.map((number, index) => (
        <motion.div
          key={index}
          className="count-number flex gap-3 rounded-xl border border-slate-200/90 bg-white p-4 shadow-sm transition hover:border-[#FECE51]/50 hover:shadow-md"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ delay: index * 0.05 }}
        >
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-[#F0F9FF] text-[#0F172A] ring-1 ring-sky-100 [&_svg]:h-5 [&_svg]:w-5">
            {number.Icon}
          </div>
          <div className="min-w-0">
            <p className="text-xl font-bold tabular-nums leading-tight text-[#0F172A] md:text-2xl">
              {counts[index].toLocaleString()}+
            </p>
            <p className="mt-1 text-[10px] font-semibold uppercase leading-snug tracking-wide text-[#727272] md:text-[11px]">
              {number.text}
            </p>
          </div>
        </motion.div>
      ))}
    </motion.div>
  );
};

export default SectionCount;
